import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { FetchReviewsResponse, FetchReviewsParams, Review } from './rate';
import axiosInstance from '../../utils/axiosInstance';

// Async thunks
export const submitReview = createAsyncThunk<
  Review,
  Review,
  { rejectValue: string }
>(
  'review/submitReview',
  async (reviewData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL}/api/review`, reviewData);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to submit review'
      );
    }
  }
);

export const getRatingStats = createAsyncThunk<any, { cardId?: string, targetType?: string }>(
  "cards/getRatingStats",
  async (queryParams, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("viart_token");

      const res = await axios.get<{ cards: any }>(
        `${process.env.REACT_APP_BACKEND_URL}/api/reviews/stats`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: queryParams,
        }
      );

      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || "Failed to load cards");
    }
  }
);

// Async thunk
export const fetchReviews = createAsyncThunk<
  FetchReviewsResponse,
  FetchReviewsParams,
  { rejectValue: string }
>(
  'review/fetchReviews',
  async (queryParams, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('viart_token');

      const response = await axiosInstance.get<FetchReviewsResponse>(
        `${process.env.REACT_APP_BACKEND_URL}/api/reviews`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          params: queryParams,
        }
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch reviews'
      );
    }
  }
);

export const deleteReview = createAsyncThunk<
  string,
  string,
  { rejectValue: string }
>(
  'review/deleteReview',
  async (reviewId, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`${process.env.REACT_APP_BACKEND_URL}/api/reviews/${reviewId}`);
      return reviewId;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to delete review'
      );
    }
  }
);